import { CommonPublishStatus } from '@/constants/geo';
import service from '.';

/**
 * CreateSpiderScheduleReq，创建爬虫计划请求参数
 */
export interface CreateSpiderScheduleReq {
  /**
   * 是否自动分析
   */
  autoAnalysis?: boolean;
  /**
   * 是否自动更新看板
   */
  autoUpdateBoard?: EAutoUpdateType;
  /**
   * 公司ID
   */
  companyId: string;
  /**
   * 词组ID
   */
  componentWords: string[];
  /**
   * 间隔天数
   */
  intervalDays: number;
  /**
   * 运行平台
   */
  platforms: string[];
  /**
   * 计划名称名称
   */
  scheduleName: string;
  /**
   * 是否发布到客户后台
   */
  publishToClient?: boolean;
  /**
   * 报告类型
   */
  reportCycle?: 'UNSET' | 'DAILY' | 'WEEKLY' | 'MONTHLY';
  /**
   * 分析报告生成后自动发布到客户后台
   */
  reportAutoPublishToClient?: 'ENABLE' | 'DISABLE';
  /**
   * 分析报告生成后自动更新到客户报表
   */
  reportAutoUpdateClientReport?: 'ENABLE' | 'DISABLE';

  [property: string]: any;
}

/**
 * 是否自动更新看板
 */
export enum EAutoUpdateType {
  Increment = 'INCREMENT',
  None = 'NONE',
  Overwrite = 'OVERWRITE',
}
/**
 * 是否需要分析
 */
export enum EAnalysisStrategy {
  pre_optimization = 'PRE_OPTIMIZATION',
  None = 'NONE',
  post_optimization = 'POST_OPTIMIZATION',
}
/**
 * 任务状态
 */
export enum ESpiderStatus {
  Disable = 'DISABLE',
  Enable = 'ENABLE',
}

/**
 * SpiderSchedulePageItem，爬虫计划列表项
 */
export interface SpiderSchedulePageItem {
  /**
   * 是否需要分析
   */
  autoAnalysis?: boolean;
  /**
   * 公司ID
   */
  companyId?: number;
  /**
   * 公司名称
   */
  companyName?: string;
  /**
   * 搜索词组ID
   */
  componentWords?: number[];
  /**
   * 扩展规则ID
   */
  expandWords?: number[];
  /**
   * 创建时间
   */
  createTime: string;
  /**
   * 扩展数量
   */
  expandCount: number;
  /**
   * 间隔天数
   */
  intervalDays?: number;
  /**
   * 下次执行时间
   */
  nextRunTime?: string;
  /**
   * 平台
   */
  platforms?: string[];
  /**
   * 任务ID
   */
  scheduleId: string;
  /**
   * 任务名称
   */
  scheduleName?: string;
  /**
   * 任务状态
   */
  status: ESpiderStatus;
  /**
   * 客户后台发布状态：1已发布 0未发布
   */
  publishStatus?: CommonPublishStatus;
  /**
   * 客户后台发布状态文案
   */
  publishStatusText?: string;

  /**
   * 更新方式
   */
  updateMode?: EAutoUpdateType;
  /**
   * 报告类型
   */
  reportCycle?: 'UNSET' | 'DAILY' | 'WEEKLY' | 'MONTHLY';
  /**
   * 分析报告生成后自动发布到客户后台
   */
  reportAutoPublishToClient?: 'ENABLE' | 'DISABLE';
  /**
   * 分析报告生成后自动更新到客户报表
   */
  reportAutoUpdateClientReport?: 'ENABLE' | 'DISABLE';
  /**
   * 词条数量
   */
  wordCount: number;
  [property: string]: any;
}
export const spiderApi = {
  list: (data: { pageIndex: number; pageSize: number; companyId: string; search?: string }) => {
    return service.post<List<SpiderSchedulePageItem>>('/schedule/spider/page', data);
  },
  get: (scheduleId: string) => {
    return service.get<SpiderSchedulePageItem>('/schedule/spider/detail', { params: { scheduleId } });
  },
  create: (data: CreateSpiderScheduleReq) => {
    return service.post('/schedule/spider/create', data);
  },
  update: (data: Partial<CreateSpiderScheduleReq>) => {
    return service.post('/schedule/spider/update', data);
  },
  delete: (data: { scheduleIds: string[] }) => {
    return service.post('/schedule/spider/delete', data);
  },
  pause: (data: { scheduleIds: string[] }) => {
    return service.post('/schedule/spider/pause', data);
  },
  resume: (data: { scheduleIds: string[] }) => {
    return service.post('/schedule/spider/resume', data);
  },
};
